module.exports = __webpack_public_path__ + "img/buildings.2cc46e11.svg";